import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {appConfig} from '../../../../config/config';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {FormsService} from '../../../../intelligence-data-entry/services/forms.service';
import {FormsAdmin} from '../../../models/forms.interface';

@Component({
  selector: 'app-forms-table',
  templateUrl: './forms-table.component.html',
  styleUrls: ['./forms-table.component.scss']
})
export class FormsTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['level', 'name', 'year', 'form', 'launched', 'questions', 'answered', 'status', 'edit'];

  @Input()
  forms!: FormsAdmin[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadForms: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(private readonly formsService: FormsService,
              private readonly router: Router,
              readonly datePipe: DatePipe) { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadForms.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadForms.emit({page: event.pageIndex, size: event.pageSize, sort: this.sort.active, direction: this.sort.direction});
  }

  openForm(value: FormsAdmin): void {
    this.router.navigate(
      // tslint:disable-next-line:max-line-length
      ['intelligencereporting/forms/' +
      value.level.toLowerCase() +
      '/' + value.name +
      '/' + value.roundOfQuestionsId +
      '/' + value.userId]).then(
      () => {
        // do nothing
      }
    );
  }

}
